'use strict';
import classNames from 'classnames';
import React from 'react';
import {I18nMessage} from '../../../../../components/I18nMessage';
import {responseFieldViewpropTypes} from '../utils';


export function TextShortFieldViewView(props) {
  return (
    <p className={classNames("TextShortFieldView", props.className)}>
      {props.value ? props.value : (
        <i>
          <I18nMessage message="forms.response.default.placeholder" />
        </i>
      )}
    </p>
  );
}

TextShortFieldViewView.propTypes = responseFieldViewpropTypes;



// WEBPACK FOOTER //
// ./src/js/form-builder/components/response/fields/TextShortFieldView/TextShortFieldViewView.js